import { Logger } from 'data/common';

function debug(eventName, params) {
    Logger.debug(`TestBench : <---------- Event Received ${eventName}`, params);
}

function bindTestEvents(EnvInstance) {
    EnvInstance.socketOn('envSet', function(args) {
        const { environment } = args;
        debug('envSet', args);

        if (environment === undefined) return Logger.error(`Arguments manquants sur l'envent socket envSet : "${args}"`);
        const profile = EnvInstance.getState().data.user;
        if (!profile.get('admin') && !profile.getIn(['user_rights', 'testbench'], []).includes(`boxes_${environment}`)) {
            Logger.error(`Pas le droit d'accès à cet envitonnement : "${args}"`);
            return EnvInstance.emit('envNotAccess', environment);
        }
        EnvInstance.dispatch({
            type: 'TESTBENCH__SET_ENV',
            environment: environment
        });
    });
}

export default function initBinds(EnvInstance) {
    bindTestEvents(EnvInstance);
}



// WEBPACK FOOTER //
// ./environments/testbench/eventsSocket/Environment/binds.js